import _get from 'lodash/get'

export class Model {
  static getAndInstantiate (value, property, ClassObject) {
    const el = _get(value, property, null)
    return el ? new ClassObject(el) : el
  }
}
